import React from 'react';
import { Link } from 'react-router-dom';
import { TermsContent } from '../components/LegalModals';

export default function TermsPage() {
  return (
    <div className="legal-page">
      <div className="legal-page-inner">
        <Link to="/" className="legal-back-link">
          ← Strona główna
        </Link>
        <div className="legal-modal legal-modal-static">
          <div className="legal-header">
            <h2>
              REGULAMIN <span>VROOM</span>
            </h2>
          </div>
          <div className="legal-body">
            <TermsContent />
          </div>
        </div>
      </div>
    </div>
  );
}
